import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Users, Trophy, Target } from 'lucide-react';
const teams = [{
  name: 'Void Serpents',
  location: 'Limassol, CY',
  game: 'Tactical FPS',
  metric: '45K Avg Viewers',
  color: 'neon-cyan'
}, {
  name: 'Neon Wraiths',
  location: 'Tallinn, EE',
  game: 'MOBA',
  metric: '78K Followers',
  color: 'neon-magenta'
}, {
  name: 'Crimson Axiom',
  location: 'Plovdiv, BG',
  game: 'Battle Royale',
  metric: '32K Avg Viewers',
  color: 'neon-red'
}, {
  name: 'Obsidian Pulse',
  location: 'Nicosia, CY',
  game: 'Racing Sim',
  metric: '21K Followers',
  color: 'neon-lime'
}];
const brands = [{
  name: 'Voltarc Peripherals',
  industry: 'Gaming Hardware',
  budget: '€15,000 / quarter',
  color: 'white'
}, {
  name: 'Cryoshift Energy',
  industry: 'Energy Drinks',
  budget: '€8,000 / quarter',
  color: 'neon-cyan'
}];
export function FeaturedRoster() {
  return <section className="py-24 bg-dark-lighter relative" id="teams" data-id="element-24">
      <div className="container mx-auto px-6" data-id="element-25">
        <div className="mb-16" data-id="element-26">
          <h2 className="font-rajdhani text-4xl font-bold mb-4 flex items-center gap-3" data-id="element-27">
            <Trophy className="text-neon-cyan" data-id="element-28" /> FEATURED ROSTERS
          </h2>
          <p className="text-gray-400" data-id="element-29">
            Top-tier verified teams looking for partners.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-24" data-id="element-30">
          {teams.map((team, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`bg-dark-card rounded-xl overflow-hidden border border-${team.color}/30 shadow-[0_0_15px_rgba(var(--tw-colors-${team.color}),0.15)] hover:shadow-[0_0_25px_rgba(var(--tw-colors-${team.color}),0.3)] transition-all group cursor-pointer`} data-id="element-31">
              <div className="h-40 bg-dark relative overflow-hidden" data-id="element-32">
                <div className={`absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--tw-colors-${team.color}),transparent_70%)] opacity-20`} data-id="element-33" />
                <div className="absolute inset-0 bg-grid-pattern opacity-30" data-id="element-34" />
                <div className="absolute bottom-3 left-3 bg-dark/80 backdrop-blur px-2 py-1 rounded text-xs font-bold border border-white/10 uppercase" data-id="element-35">
                  {team.game}
                </div>
              </div>
              <div className="p-5" data-id="element-36">
                <h3 className="font-rajdhani text-2xl font-bold mb-2 group-hover:text-neon-cyan transition-colors" data-id="element-37">
                  {team.name}
                </h3>
                <div className="flex items-center gap-2 text-sm text-gray-400 mb-4" data-id="element-38">
                  <MapPin className="w-4 h-4" data-id="element-39" /> {team.location}
                </div>
                <div className="bg-dark p-3 rounded border border-white/5 flex items-center justify-between" data-id="element-40">
                  <span className="text-xs text-gray-500" data-id="element-41">Reach</span>
                  <span className="font-bold text-sm flex items-center gap-1" data-id="element-42">
                    <Users className="w-3 h-3 text-neon-cyan" data-id="element-43" /> {team.metric}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mb-16" id="brands" data-id="element-44">
          <h2 className="font-rajdhani text-4xl font-bold mb-4 flex items-center gap-3" data-id="element-45">
            <Target className="text-neon-magenta" data-id="element-46" /> ACTIVE BRANDS
          </h2>
          <p className="text-gray-400" data-id="element-47">
            Sponsors actively deploying capital on Pixelkeep.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-48">
          {brands.map((brand, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-dark-card border border-white/10 p-6 rounded-xl flex items-center justify-between hover:border-neon-magenta/50 transition-colors" data-id="element-49">
              <div className="flex items-center gap-4" data-id="element-50">
                <div className="w-16 h-16 rounded bg-dark border border-white/5 flex items-center justify-center" data-id="element-51">
                  <span className="font-rajdhani font-bold text-xl" data-id="element-52">
                    {brand.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-53">
                  <h3 className="font-rajdhani text-2xl font-bold" data-id="element-54">
                    {brand.name}
                  </h3>
                  <p className="text-sm text-gray-400" data-id="element-55">{brand.industry}</p>
                </div>
              </div>
              <div className="text-right" data-id="element-56">
                <div className="text-xs text-gray-500 uppercase mb-1" data-id="element-57">
                  Active Budget
                </div>
                <div className="font-rajdhani font-bold text-xl text-neon-lime" data-id="element-58">
                  {brand.budget}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}